import React, { useState, useEffect } from "react";
import fetchData from "../Services/ApiCaller";
import { useLocation, Link } from "react-router-dom";

import logo_compounds from "../Images/virtuous_compounds.png"
import Header_menu from "../Components/Partials/Header_menu"

function Result(){

    const location = useLocation();
    var smiles = location.state;             //Preleva input compounds
    
    //Body request
    const [body, setBody] = useState({ COMPOUNDS: {} });

    function createBody(smiles){
        smiles = smiles.replace(/(\r\n|\n|\r)/gm, " ").split(/(\s+)/);      //Pulizia input

        smiles.map((smile, index) => {
            let tmp = { ...body };
            if(smile !== " " && smile !== ""){
                tmp.COMPOUNDS["row" + index] = smile
                setBody(tmp)
            }
        })
    }

    //Response
    const [predictedLogP, setpredictedLogP] = useState({});

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        createBody(smiles)      //Creo il body con i giusti parametri
        const apiResponse = fetchData(body);
        const result = Promise.resolve(apiResponse);

        result.then((value) => {
        if (value.Data?.SMILES !== undefined) {
            setpredictedLogP(value.Data);
            //console.log(value.Data);
        } else {
            setpredictedLogP(undefined);
        }
        });
    }, []);


    return <>
        <section className="flex flex-col h-full antialiased bg-neutral-800 ">
            <Header_menu />
            <main className="container relative flex flex-col flex-auto gap-8 p-8 mx-auto my-8 card">

                {/*Action Top*/}
                <div className="flex items-center gap-4">
                    <img src={logo_compounds} alt="Virtuous Compounds" className="w-40 h-40 p-4 bg-gray-100 rounded-full" />
                    <div>
                        <h1 className="font-bold uppercase ">Virtuous Compounds</h1>
                        <h2 className="font-bold text-gray-500 uppercase ">Virtuous Bitter/Sweet</h2>
                    </div>
                </div>


                {/*Properties*/}
                <div className="p-4 border-2 rounded-lg">
                    {/*Action Top*/}
                    <div className="flex mb-8">
                        <div className="flex gap-4">
                            <div className="flex flex-col">
                                <h2 className="font-bold">Results</h2>
                            </div>
                        </div>
                    </div>

                    {/*ligand 1*/}
                    <div className="relative mb-8 overflow-x-auto border-2 sm:rounded-lg">
                        <table className="w-full text-sm text-left text-neutrals-500 ">
                            <thead className="text-xs uppercase text-neutrals-700 bg-neutrals-50 ">
                                <tr>
                                    <th scope="col" className="p-4">Compound</th>
                                    <th scope="col" className="px-6 py-3"> Applicability Domain Check </th>
                                    <th scope="col" className="px-6 py-3"> Class </th>
                                    <th scope="col" className="px-6 py-3"> Probability </th>
                                    <th scope="col" className="px-6 py-3"> Descriptors </th>
                                </tr>
                            </thead>

                            <tbody>

                            {predictedLogP.SMILES === undefined ?
                                <tr>
                                    <td className="w-10 px-6 py-4 font-bold font-headings text-neutrals-900"></td>
                                    <td className="w-10 px-6 py-4 font-bold font-headings text-neutrals-900"></td>
                                    <td className="w-10 px-6 py-4 font-bold font-headings text-neutrals-900">
                                        <div role="loading">
                                            <svg aria-hidden="true" className="mx-auto w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                                            </svg>
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </td>
                                    <td className="w-10 px-6 py-4 font-bold whitespace-nowrap"></td>
                                    <td className="w-10 px-6 py-4 space-y-4"></td>
                                </tr>
                                :
                                predictedLogP.SMILES?.map((smile, index) =>{
                                    let labelCheckColor = predictedLogP.CheckAD[index] ? "text-emerald-500" : "text-red-500"
                                    labelCheckColor ="w-10 px-6 py-4 text-xl font-bold whitespace-nowrap " + labelCheckColor
                                    return <>
                                    <tr className="border-b last-of-type:border-none odd:bg-neutrals-100/20 hover:bg-neutrals-100/50">
                                        <td className="w-10 px-6 py-4 font-bold font-headings text-neutrals-900"> 
                                            {smile}
                                        </td>
                                        <td className={labelCheckColor}> 
                                            {predictedLogP.CheckAD[index] !==undefined ? predictedLogP.CheckAD[index] ? "True" : "False" : ""}
                                        </td>
                                        <td className="w-10 px-6 py-4 font-bold font-headings text-neutrals-900">
                                            {predictedLogP.Class[index] !==undefined ? predictedLogP.Class[index] : ""}
                                        </td>
                                        <td className="w-10 px-6 py-4 font-bold whitespace-nowrap"> 
                                            <span className="px-6 py-2 ml-4 font-bold text-white rounded-lg bg-secondary-500">{predictedLogP.Probability[index] !==undefined ? predictedLogP.Probability[index].toFixed(2) : ""}</span> 
                                        </td>
                                        <td className="w-10 px-6 py-4 space-y-4">
                                            <a className="w-full text-center cta cta-secondary" href="#No-link">Only selected</a>
                                        </td>
                                    </tr>
                                    </>
                                })
                            }

                            </tbody>
                        </table>
                    </div>

                </div>

                {/*Action bottom*/}
                <div className="mx-auto my-2 mt-auto">
                    <div className="flex gap-4">
                        <Link to="/compounds" className="cta cta-primary">New Prediction</Link>
                    </div>
                </div>
            </main> 
        </section>

    </>;
}

export default Result;